<template>
	<div class="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
		<IconList :icons="icons"></IconList>
	</div>
</template>

<script>

import GalleryHeader from '@/Layouts/GalleryHeader'

export default {
	layout: GalleryHeader,
}
</script>

<script setup>
import IconList from '@/Layouts/IconList.vue';

const props = defineProps({
	icons: Object
})
</script>
